import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IContactPersonResponse, ImmomioIconName } from '@resident-nx/shared';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  selector: 'rs-web-contact-preview',
  standalone: true,
  imports: [IconWebComponent],
  templateUrl: './contact-preview.component.html',
  styleUrl: './contact-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactPreviewComponent {
  @Input() contact: IContactPersonResponse;
  @Input() showSelectionArrowIndicator = false;

  public immomioIconName = ImmomioIconName;
}
